import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`font-mono2 text-xs sm:text-sm uppercase tracking-[0.3em] flex items-center gap-3 ${
      dark ? "text-[var(--accent)]" : "text-[var(--accent-soft)]"
    }`}
  >
    <span className={`inline-block h-px w-10 ${dark ? "bg-[var(--accent)]" : "bg-[var(--accent-soft)]"}`} />
    {children}
  </p>
);
